export const structureVersion: string = '1.0.0'
